/**
 * Rotates an image blob 90 degrees clockwise. The image editor, admin's lightbox Rotate and the async gallery's Rotate
 * all use this one implementation.
 *
 * A DOM canvas, not OffscreenCanvas: OffscreenCanvas 2D needs Safari/iOS 16.4, above the iOS 15 support floor, and the
 * async gallery runs on customers' phones.
 *
 * @param type The output blob type. Defaults to the input blob's type.
 */
export async function rotateBlob(blob: Blob, { type }: { type?: string } = {}): Promise<Blob> {
	let bitmap: ImageBitmap | undefined;
	try {
		bitmap = await createImageBitmap(blob);
		const canvas = document.createElement("canvas");
		canvas.width = bitmap.height;
		canvas.height = bitmap.width;
		const context = canvas.getContext("2d");
		if (!context) {
			throw new Error("Failed to get 2D context");
		}
		context.translate(canvas.width, 0);
		context.rotate(Math.PI / 2);
		context.drawImage(bitmap, 0, 0);
		return await new Promise<Blob>((resolve, reject) =>
			canvas.toBlob((rotated) => (rotated ? resolve(rotated) : reject(new Error("Failed to encode the rotated image"))), type ?? blob.type)
		);
	} finally {
		bitmap?.close();
	}
}
